export default {
    methods: {
        getProductName(){
            //  get product name based on language
            const locale = this.$i18n.locale;
            if(locale === 'en'){
                return this.product.Name
            }
            if(!this.product.Translations){
                return this.product.Name
            }
            const translatedName = this.product.Translations.find(t => t.Culture === locale);
            return translatedName && translatedName.Name ? translatedName.Name : this.product.Name;
        },

        getProductDescription(){
            //  get product description based on language
            const locale = this.$i18n.locale;
            if(locale === 'en' || !this.product.Translations){
                return this.product.ShortDescription
            }
            const translatedName = this.product.Translations.find(t => t.Culture === locale);
            return translatedName && translatedName.Description ? translatedName.Description : this.product.ShortDescription;
        }
    }
};

